<template>
	<v-layout row wrap justify-center>
		<v-flex xs12 sm12 md12>
			<div>
				<v-container>
					<v-layout row wrap justify-center>
						<v-flex sm11 xs11 md12>
							<v-img src="../../Photos/oneonone.jpg"></v-img>
						</v-flex>
						<v-flex sm11 xs11 md12>
							<div
								class="pa-4 "
								style="border-bottom: 1px solid black; border-top: 1px solid black;"
							>
								<h1 style="text-align:center;" class="text-uppercase">
									{{ eventClass.title }}
								</h1>
							</div>
						</v-flex>
						<v-flex xs11 sm9 md9>
							<div class="pa-4 ">
								<p>{{ eventClass.about }}</p>
							</div>
						</v-flex>
						<v-flex xs11 sm3 md3>
							<div class="pa-4 ">
								<h4
									style="text-align: center; border-bottom: 1px solid black;"
									class="pa-1"
								>
									{{ eventClass.title }} Price
								</h4>
								<ul v-for="c in eventClass.prices" :key="c">
									<li class="pa-1">
										{{ c }}
									</li>
								</ul>
							</div>
						</v-flex>
					</v-layout>
				</v-container>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	props: {
		eventClass: {
			type: Object,
			required: true,
		},
	},
};
</script>
